const paymentMethodNames = {
    BANK_SLIP: "Boleto com PIX",
    CREDIT_CARD: "Cartão de crédito",
}

export const getPlanChangeConfirmation = (currentPlan = {}, nextPlan = {}) => {
    const currentAutomaticRenovation = Number(currentPlan?.automatic_renovation)
    const nextAutomaticRenovation = Number(nextPlan?.automatic_renovation)

    if (currentAutomaticRenovation !== nextAutomaticRenovation) {
        if (nextAutomaticRenovation) {
            return {
                title: "Ativação de renovação automática",
                description: "Deseja realmente ativar a renovação automática?",
                text: "Ao ativar a renovação automática, as cobranças passarão a ser emitidas automaticamente para que a licença seja renovada!",
            }
        }

        let text = "Ao desativar a renovação automática, as cobranças não serão mais emitidas automaticamente!"
        if (!currentPlan?.payment_by_partner) {
            text += ` Sua licença permanecerá ativa até ${currentPlan?.expires_in || "-"}`
        }
        return {
            title: "Desativação da renovação automática",
            description: "Deseja realmente desativar a renovação automática?",
            text,
        }
    }

    const currentDefaultMethod = currentPlan?.default_method || "BANK_SLIP"
    const nextDefaultMethod = nextPlan?.default_method || "BANK_SLIP"
    if (currentDefaultMethod !== nextDefaultMethod) {
        const methodName = paymentMethodNames[nextDefaultMethod] || "a opção selecionada"
        return {
            title: "Alteração do pagamento padrão",
            description: `Deseja definir ${methodName} como pagamento padrão?`,
            text: "A nova forma de pagamento será usada nas próximas cobranças da assinatura.",
        }
    }

    return null
}
